import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { SharedModule } from '@shared/shared.module';


@Component({
  selector: 'app-public-digilocker-callback',
  imports: [CommonModule, SharedModule],
  templateUrl: './public-digilocker-callback.component.html',
  styleUrl: './public-digilocker-callback.component.scss',
})
export class PublicDigilockerCallbackComponent implements OnInit {

  status = signal<'loading' | 'success' | 'cancelled' | 'failed'>('loading');
  countdown = signal(10);

  constructor() { }

  async ngOnInit(): Promise<void> {
    try {
      // Immediately try to close the in-app browser
      await this.closeBrowser();
      this.status.set('loading');
      this.startTimer();
    } catch (error) {
      console.error('Error in DigiLocker callback page:', error);
      this.status.set('failed');
      // Final attempt to close browser
      await this.closeBrowser();
    }
  }

  startTimer() {
    this.countdown.set(10);
    const interval = setInterval(() => {
      const value = this.countdown();
      if (value <= 1) {
        clearInterval(interval);
      } else {
        this.countdown.set(value - 1);
      }
    }, 1000);
  }

  /** Reusable safe close function */
  private async closeBrowser(): Promise<void> {
    try {
      await Browser.close();
      console.log('Browser closed successfully from callback page');
    } catch (err) {
      console.warn('Browser.close() failed:', err);
    }
  }
}